'use strict';

class MdInputController {
    constructor() {
        
    }

    $onInit() {
        
    }
}

export default MdInputController;


// WEBPACK FOOTER //
// ./src/app/common/core/util/material/md-input/md-input.controller.js